<template>
  <div class="resource-play">
    <div class="title">
      <div class="title-left">
        <i @click="handleGood" v-if="!doUserGood" class="iconfont icondianzan1"></i>
        <i v-else class="iconfont icondianzan1" style="color:#3b8bff"></i>
        <i @click="handleGrade" v-if="!doUserGrade" class="iconfont icon-solid-star"></i>
        <i v-else class="iconfont icon-solid-star" style="color:rgb(248, 171, 45)"></i>
        <i @click="showMessage = true" class="iconfont icon-solid-chat"></i>
        <span>{{ totalDatas }}</span>
      </div>
      <div class="title-right">
        <i class="iconfont iconeye"></i>
        <span>{{ resResource ? resResource.visitCount : 0 }}</span>
        <i @click="showDetail = true" class="iconfont iconliebiao-01"></i>
      </div>
    </div>
    <video v-if="type === 9030" controls :src="src"></video>
    <div v-if="type === 9031" id="demo"></div>
    <img v-if="type === 9032" :src="src" alt="" />
    <!-- <Back /> -->
    <!-- 详情 -->
    <van-popup v-if="resResource" class="detail" v-model="showDetail" round position="bottom" :style="{height: '60%'}">
      <div class="user">
        <img v-if="resResource.userFace" :src="$isCdn(resResource.userFace)" alt="" />
        <img v-else src="@/assets/image/avatar.svg" alt="" />
        <div style="flex:1;width:0">
          <div class="name van-ellipsis">{{ resResource.userName }}</div>
          <div class="org van-ellipsis">{{ resResource.orgName }}</div>
        </div>
      </div>
      <div class="item">
        <span class="label">名称</span>
        <div>{{ resResource.resourceName }}</div>
      </div>
      <div v-if="resResource.createtime" class="item">
        <span class="label">日期</span>
        <div>{{ resResource.createtime | formatDate('yyyy-MM-dd') }}</div>
      </div>
      <div v-if="resResource.subjectInfo.trim()" class="item">
        <span class="label">科目</span>
        <div>{{ resResource.subjectInfo }}</div>
      </div>
      <div v-if="labelDataVoList.length > 0" class="item">
        <span class="label">标签</span>
        <div class="type-container">
          <span class="type" v-for="(item, index) in labelDataVoList" :key="index">{{ item.name }}</span>
        </div>
      </div>
      <div v-if="resResource.resourceMask" class="item">
        <span class="label">简介</span>
        <div>{{ resResource.resourceMask }}</div>
      </div>
    </van-popup>
    <!-- 详情 -->
    <!-- 打分 -->
    <div class="rate-panel">
      <van-dialog
        @cancel="cancel"
        @confirm="confirm"
        :value="showRate"
        title=""
        show-cancel-button
        confirmButtonColor="#4465f3"
      >
        <div class="rate-panel-container">
          <van-rate v-model="rateValue" :size="35" color="#ffd21e" void-icon="star" void-color="#eee" />
        </div>
      </van-dialog>
    </div>
    <!-- 打分 -->
    <!-- 留言 -->
    <van-popup
      :lock-scroll="false"
      class="message"
      v-model="showMessage"
      round
      position="bottom"
      :style="{height: '60%'}"
    >
      <div style="height:calc(60vh - 62px);overflow-y:auto" class="wrapper" ref="wrapper">
        <div class="mes-container content">
          <div class="mes-title">
            <span>留言</span>
            <span style="color: #909399;">共计{{ totalDatas }}条</span>
          </div>

          <div class="mes-list">
            <div v-for="(item, index) in messgaes" :key="index" class="mes-item">
              <img v-if="item.userFace" :src="$isCdn(item.userFace)" alt="" />
              <img v-else src="@/assets/image/avatar.svg" alt="" />
              <div class="mes-info">
                <div class="name">{{ item.userName }}</div>
                <div class="time">{{ item.createtime | formatDate('yyyy-MM-dd') }}</div>
                <div class="mes">{{ item.commentContext }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="mes-btn">
        <div class="i">
          <input maxlength="200" v-model.trim="messgaesValue" placeholder="请输入你的留言" type="text" />
        </div>
        <div @click="addCommend" class="btn">发送</div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import {getResourcePlay, selectComment, sourceSaveAction, addComment} from '@/api'
import Pdfh5 from 'pdfh5'
import 'pdfh5/css/pdfh5.css'
export default {
  name: 'resourcePlay',
  data() {
    return {
      type: '',
      src: '',
      pdfh5: null,
      resResource: null,
      labelDataVoList: [],
      messgaes: [],
      totalDatas: 0,
      maxPage: 1,
      pageNo: 1,
      messgaesValue: '',
      showDetail: false,
      doUserGrade: false,
      doUserGood: false,
      showRate: false,
      rateValue: 0,
      showMessage: false
    }
  },
  watch: {
    showMessage(val) {
      if (val) {
        this.$nextTick(() => {
          const ele = document.querySelector('.wrapper')
          ele.addEventListener('scroll', this.onScroll)
        })
      }
    }
  },
  created() {
    this.init()
    this.getCommend(false)
  },
  methods: {
    onScroll(e) {
      const {scrollHeight, clientHeight, scrollTop} = e.target
      if (clientHeight + scrollTop === scrollHeight) {
        if (this.maxPage > this.pageNo) {
          this.pageNo++
          this.getCommend(true)
        }
      }
    },
    async addCommend() {
      if (!this.messgaesValue) return
      const params = {
        attributeObj: this.$route.params.id,
        context: this.messgaesValue
      }
      const result = await addComment(params)
      if (result.code === 0) {
        const ele = document.querySelector('.wrapper')
        ele.scrollTop = 0
        this.messgaesValue = ''
        this.pageNo = 1
        this.getCommend(false)
      }
    },
    async getCommend(type) {
      const params = {
        resourceId: this.$route.params.id,
        pageNo: this.pageNo
      }
      const {data, totalDatas} = await selectComment(params)
      this.totalDatas = totalDatas
      this.maxPage = Math.ceil(totalDatas / 10)
      if (type) {
        this.messgaes.push(...data)
      } else {
        this.messgaes = [...data]
      }
    },
    init() {
      getResourcePlay(this.$route.params.id).then(res => {
        const {resResource, labelDataVoList, doUserGood, doUserGrade, resourceAuth} = res.data
        this.resResource = resResource
        this.labelDataVoList = labelDataVoList
        this.doUserGood = doUserGood
        this.doUserGrade = doUserGrade
        this.type = resResource.resourceFileType
        /* 判断权限 */
        if (!this.$route.query.pass) {
          if (!resourceAuth.auth) {
            if (resourceAuth.authType === 9072) {
              // 密码
              return this.$router.replace(`/validPwd/${this.$route.params.id}?type=2`)
            }
            // return 401
            return this.$router.replace('/401')
          }
        }
        if (this.type === 9030) {
          this.src = this.$isCdn(resourceAuth.resourcePath)
        }
        if (this.type === 9031) {
          this.src = this.$isCdn(resourceAuth.resourcePath)
          this.$nextTick(() => {
            this.pdfh5 = new Pdfh5('#demo', {
              pdfurl: this.src
            })
            this.pdfh5.on('complete', function(status, msg, time) {
              console.log('状态：' + status + '，信息：' + msg + '，耗时：' + time + '毫秒，总页数：' + this.totalNum)
            })
          })
        }
        if (this.type === 9032) {
          this.src = this.$isCdn(resourceAuth.resourcePath)
        }
      })
    },
    async handleGood() {
      const params = {
        resourceId: this.$route.params.id,
        score: 0,
        type: 1
      }
      const {data} = await sourceSaveAction(params)
      if (data) {
        this.$Toast.success('点赞成功')
        this.doUserGood = true
      }
    },
    handleGrade() {
      this.showRate = true
    },
    cancel() {
      this.showRate = false
    },
    async confirm() {
      const params = {
        resourceId: this.$route.params.id,
        score: this.rateValue,
        type: 2
      }
      const {data} = await sourceSaveAction(params)
      if (data) {
        this.$Toast.success('评分成功')
        this.doUserGrade = true
        this.cancel()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.iconfont {
  font-size: 20px !important;
}
.resource-play {
  height: 100vh;
  .title {
    height: 40px;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 16px 0 6px;
    i {
      font-size: 24px;
      vertical-align: middle;
      color: #c0c4cc;
    }
    span {
      vertical-align: middle;
      color: #c0c4cc;
    }
    .title-left {
      i {
        margin-left: 16px;
      }
      span {
        margin-left: 4px;
      }
    }
    .title-right {
      span {
        margin-right: 10px;
      }
    }
  }
  video {
    background: #000;
    width: 100%;
    object-fit: contain;
  }
  img {
    width: 100%;
  }
}
#demo {
  width: 100%;
  height: calc(100vh - 40px);
  height: 100vh;
}
.detail {
  .user {
    padding: 20px;
    display: flex;
    align-items: center;
    img {
      width: 48px;
      height: 48px;
      border-radius: 50%;
      margin-right: 10px;
    }
    .name {
      font-weight: 700;
      color: #303133;
    }
    .org {
      color: #909399;
    }
  }
  .item {
    padding: 10px 20px;
    position: relative;
    padding-left: 70px;
    div {
      word-break: break-all;
    }
    span.label {
      position: absolute;
      top: 10px;
      left: 20px;
      color: #909399;
    }
    .type-container {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
    }
    span.type {
      background: #f4f6f9;
      border-radius: 28px;
      padding: 6px 10px;
      margin: 0 6px 6px 0;
    }
  }
}
.rate-panel-container {
  text-align: center;
  padding: 60px 0;
}

.message {
  padding-bottom: 62px;
  .mes-btn {
    position: fixed;
    height: 62px;
    bottom: 0;
    left: 0;
    width: 100%;
    background: #fbfcfd;
    padding: 10px 16px;
    display: flex;
    align-items: center;
    div.i {
      flex: 1;
      margin-right: 12px;
      height: 100%;
      border-radius: 40px;
      overflow: hidden;
    }
    input {
      width: 100%;
      height: 100%;
      outline: none;
      border: none;
      padding: 0 10px;
      background: #eef0f3;
      &::-webkit-input-placeholder {
        background: #eef0f3;
      }
    }
    div.btn {
      height: 40px;
      width: 70px;
      border-radius: 6px;
      background: rgba(68, 101, 243, 1);
      color: #fff;
      text-align: center;
      line-height: 40px;
    }
  }

  .mes-container {
    padding: 16px 16px 0;
    .mes-title {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    .mes-list {
      .mes-item {
        position: relative;
        padding: 20px 0 20px 60px;
        border-bottom: 1px solid #f0f3f6;
        img {
          position: absolute;
          left: 0;
          top: 20px;
          width: 48px;
          height: 48px;
          border-radius: 50%;
        }
        .mes-info {
          .name {
            color: #303133;
            font-weight: 500;
          }
          .time {
            color: #909399;
            font-weight: 500;
            margin-top: 10px;
          }
          .mes {
            word-break: break-all;
            color: #606266;
            margin-top: 15px;
          }
        }
      }
    }
  }
}
</style>
